import { render, staticRenderFns } from "./warn-34.vue?vue&type=template&id=642a80c6&scoped=true"
import script from "./warn-34.vue?vue&type=script&lang=js"
export * from "./warn-34.vue?vue&type=script&lang=js"
import style0 from "./warn-34.vue?vue&type=style&index=0&id=642a80c6&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642a80c6",
  null
  
)

export default component.exports